import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["titleField", "select"];

  connect() {
    this.update();
  }

  update() {
    this.titleFieldTarget.classList.toggle("d-none", this.selectedCount() <= 1);
  }

  selectedCount() {
    const select = this.selectTarget;
    if (select.multiple) {
      return Array.from(select.selectedOptions).length;
    }
    return select.value ? 1 : 0;
  }
}
